import News from "../../component/News";

export const NewsContent = () => {
  return <News />;
};